import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicFeedback({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.38 1.25c1.01 0 1.87.76 1.87 1.75v1.62l.01-.01.71.47c.49.32.78.87.78 1.46V13c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75V6.54c0-.59.3-1.14.78-1.46l.72-.48V3c0-.94.77-1.67 1.72-1.74l.16-.01zm1.87 6.65l-4.28 2.85c-.59.4-1.35.4-1.94 0L2.75 7.9V13c0 .12.08.22.2.24l.05.01h10c.14 0 .25-.11.25-.25V7.9zm-1.88-5.15H4.63c-.23 0-.38.13-.38.25v4.1l3.61 2.4c.07.05.15.06.23.03l.05-.02 3.61-2.41V3c0-.1-.11-.21-.28-.24l-.1-.01zM8 6.1a.65.65 0 110 1.3H6a.65.65 0 110-1.3zm2-2.25a.65.65 0 110 1.3H6a.65.65 0 110-1.3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicFeedback.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicFeedback.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicFeedback svgRef={ref} {...props} />);
export default ForwardRef;
